/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Sagas for BreadCrumbs component
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import { SagaIterator } from 'redux-saga';
import { select, takeEvery } from 'redux-saga/effects';

import { BREADCRUMBS_GO_BACK } from './breadCrumbsConstants';
import { makeSelectBreadCrumbsData } from './breadCrumbsSelectors';
import { breadCrumbGoBack } from './utils/breadCrumbsGoBack';

export function* breadCrumbsGoBackSaga(): SagaIterator {
    const data = yield select(makeSelectBreadCrumbsData());
    breadCrumbGoBack(data);
}

export function* breadCrumbsSagas() {
    yield takeEvery(BREADCRUMBS_GO_BACK, breadCrumbsGoBackSaga);
}
